$(function() {
	$("#contacts-pane .expander").on("click", function() {
		$(this).closest(".block").find(".expandable").addClass("visible");
		$(this).addClass("expanded");
		return false;
	});
});